/* global window.ParamsDataPopin */

import * as Utils from './components/utils.js';

import Autocompletion from './components/autocompletion.js';

export default formSigninRecruteurs => {
    console.log('formSigninRecruteurs');

    const dataAction = formSigninRecruteurs.getAttribute('data-action');
    const emeilRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const inputPassword = formSigninRecruteurs.querySelector('#form-signin-recruteurs-password');
    const inputPasswordFormat = formSigninRecruteurs.querySelectorAll('[data-check]');
    const inputSubmit = formSigninRecruteurs.querySelector('#form-signin-recruteurs-submit');
    const dataSigninFields = formSigninRecruteurs.querySelectorAll('[data-signin]');
    const lengthLimit = 14;
    const zipCodeRegex = /^([0-ÿ\- ]{4,19})$/;
    const numericRegex = /[0-9]/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const specialRegex = /[!"#$%&'()\*\+\-\.\/:<=>?@\[\]^_`{|}~]/;
    let init = true;
    let validity = true;
    let password = false;
    let already_used_global = false;

    function hideEntiteInfo() {
        /*  const field = document.getElementById('form-signin-recruteurs-entite');
          field.closest('.fr-input-group').classList.add('fr-input-group--error');
          field.setAttribute('aria-invalid', true);
          validity = false;
          field.classList.add('fr-input--error');
          const describedby = field.getAttribute('aria-describedby').split(' ');
          const msgId = describedby.length > 1 ? 1 : 0;
          const msg = document.getElementById(describedby[msgId]);
          msg.classList.remove('hide');*/
        document.getElementById('form-signin-recruteurs-entite-info').style.display = "none";
    }

    // autocompletion du champ entité en fonction de la fonction publique choisie
    function entitiesAutocompletion() {
        let alldatas = {};
        let datas = [];

        function exist(value) {
            for (let key in alldatas) {
                for (let data of alldatas[key]) {
                    console.log(data.label);
                }
            }
        }

        function search(id) {
            datas = alldatas[id];
        }

        const hiddenPart = formSigninRecruteurs.querySelector('.form-signin-recruteurs-hidden_part');

        const radio_fonction_publique = formSigninRecruteurs.querySelectorAll('.fonction_publique input');
        radio_fonction_publique.forEach((input) => {
            input.onclick = () => {
                search(input.value);
                autocomplete.update(datas);
                hiddenPart.style.display = "block";
                input_entity.value = "";
                document.getElementById('form-signin-recruteurs-entite-info').style.display = "none";
            }
        });

        function closeAutocompleteEntite(value, hasEntry, already_used) {
            const field = document.getElementById('form-signin-recruteurs-entite');
            const entity_error = document.querySelector('#form-signin-recruteurs-entite-error');
already_used_global = already_used;
            if (!hasEntry) {
                console.log("!!hasEntry");
                already_used_global = false;
                document.querySelector('#form-signin-recruteurs-entite-info .fr-text').innerHTML = `La demande d’ajout de l’entité « ${value} » sera étudiée auprès de nos équipes.`
                document.getElementById('form-signin-recruteurs-entite-info').style.display = "flex";
                input_entity_codeApi.value = "";


                hideErrorMessage(field);
                document.querySelector('#form-signin-recruteurs-entite-error').style.display = "none";
                field.closest('.fr-input-group').classList.remove('fr-input-group--error');
                field.classList.remove('fr-input--error');
                field.setAttribute('aria-invalid', false);
                field.classList.add('fr-input--valid');
                const describedby = field.getAttribute('aria-describedby').split(' ');
                const msgId = describedby.length > 1 ? 1 : 0;
                const msg = document.getElementById(describedby[msgId]);
                msg.classList.add('hide');
                msg.style.display = "none";

            } else {
                if (already_used === "true") {
                    
                    console.log("already_used");
                    entity_error.closest('.fr-input-group').classList.add('fr-input-group--error');
                    field.classList.add('fr-input--error');
                    entity_error.innerHTML = `Un compte employeur existe déjà pour cette entité.`;
                    entity_error.classList.remove('hide');
                    entity_error.style.display = "flex";
                } else {
                    entity_error.closest('.fr-input-group').classList.remove('fr-input-group--error');
                    field.classList.remove('fr-input--error');
                    entity_error.innerHTML = ``;
                    entity_error.classList.add('hide');
                    entity_error.style.display = "none";
                }
                hideEntiteInfo();
            }

            if (field.value === "") {
                field.closest('.fr-input-group').classList.add('fr-input-group--error');
                field.setAttribute('aria-invalid', true);
                field.classList.add('fr-input--error');
                document.getElementById('form-signin-recruteurs-entite-info').style.display = "none";
                addErrorMessage(field);
            }
        }

        const input_entity = document.getElementById("form-signin-recruteurs-entite");
        const input_entity_codeApi = document.getElementById("form-signin-recruteurs-entite-code_api");
        const autocomplete = new Autocompletion(input_entity, {
            onselect(value) {
                input_entity_codeApi.value = value;
            },
            onclose(value, hasEntry, already_used) {
                closeAutocompleteEntite(value, hasEntry, already_used);
            },
            onblur(value, hasEntry, already_used) {
                closeAutocompleteEntite(value, hasEntry, already_used);
            }
        });

        const ajaxData = new FormData();
        ajaxData.append('action', "get_entities");
        ajaxData.append('nonce', window.ParamsDataPopin.nonce);

        const request = new XMLHttpRequest();
        const url = window.ParamsDataPopin.wp_ajax_url;
        request.open('POST', url, true);
        request.send(ajaxData);

        request.onload = () => {
            let response = JSON.parse(request.response);
            alldatas = response.datas;
            search(radio_fonction_publique[0].value);
            autocomplete.update(datas);
        }
    }

    entitiesAutocompletion();

    function hideErrorMessage(field) {
        const target = field.getAttribute('type') === 'radio' ? field.closest('fieldset') : field;
        const describedby = target.getAttribute('aria-describedby').split(' ');
        const msgId = describedby.length > 1 ? 1 : 0;
        const msg = document.getElementById(describedby[msgId]);
        msg.style.display = "none";
    }

    function addErrorMessage(field) {
        const target = field.getAttribute('type') === 'radio' ? field.closest('fieldset') : field;
        const describedby = target.getAttribute('aria-describedby').split(' ');
        const msgId = describedby.length > 1 ? 1 : 0;
        const msg = document.getElementById(describedby[msgId]);

        const html = `${target.dataset.message}`;

        msg.innerHTML = html;
        msg.classList.remove('hide');
        msg.style.display = "block";

        field.addEventListener('change', formFieldsValidate);
    }

    function formFieldsValidate() {
        if (init === true) return;

        validity = true;

        for (const field of formSigninRecruteurs.querySelectorAll('[required]')) {
            if (!field.checkValidity()) {
                if (field.getAttribute('type') === 'radio') {
                    field.closest('.fr-input-group').classList.add('fr-input-group--error');

                } else {
                    field.closest('.fr-input-group').classList.add('fr-input-group--error');
                }

                field.classList.add('fr-input--error');

                field.setAttribute('aria-invalid', true);

                validity = false;

                addErrorMessage(field);
            } else {

                if (field.getAttribute('type') === 'radio') {
                    field.closest('.fr-input-group').classList.remove('fr-input-group--error');
                    field.setAttribute('aria-invalid', false);
                } else {

                    if (field.type === 'email') {
                        if (!field.value.match(emeilRegex)) {
                            field.closest('.fr-input-group').classList.add('fr-input-group--error');
                            field.setAttribute('aria-invalid', true);
                            validity = false;
                            field.classList.add('fr-input--error');
                            addErrorMessage(field);
                        } else {
                            field.closest('.fr-input-group').classList.remove('fr-input-group--error');
                            field.classList.remove('fr-input--error');
                            field.setAttribute('aria-invalid', false);
                            field.classList.add('fr-input--valid');
                        }
                    } else {
                        if (field.dataset.signin === 'user_postalcode') {
                            if (!field.value.match(zipCodeRegex)) {
                                field.closest('.fr-input-group').classList.add('fr-input-group--error');
                                field.setAttribute('aria-invalid', true);
                                validity = false;
                                field.classList.add('fr-input--error');
                                addErrorMessage(field);
                            } else {
                                field.closest('.fr-input-group').classList.remove('fr-input-group--error');
                                field.setAttribute('aria-invalid', false);
                                field.classList.remove('fr-input--error');

                            }
                        } else {
                            field.closest('.fr-input-group').classList.remove('fr-input-group--error');
                            field.setAttribute('aria-invalid', false);
                            field.classList.remove('fr-input--error');
                            field.classList.add('fr-input--valid');
                        }

                        if (field.closest('.fr-input-group').querySelector('.message.error')) {
                            field.closest('.fr-input-group').querySelector('.message.error').innerHTML = '';
                        }
                    }
                }

                hideErrorMessage(field);

                // force erreur si l'entité est déjà utilisée
                if (field.id == "form-signin-recruteurs-entite") {
                    if (already_used_global) {
                        console.log("------------------");
                        field.classList.add('fr-input--error');
                        field.closest('.fr-input-group').classList.add('fr-input-group--error');
                        field.setAttribute('aria-invalid', true);
                        const describedby = field.getAttribute('aria-describedby').split(' ');
                        const msgId = describedby.length > 1 ? 1 : 0;
                        const msg = document.getElementById(describedby[msgId]);
                        msg.classList.remove('hide');
                        msg.style.display = "block";
                        hideEntiteInfo();
                    }
                    



                    console.log("--->", already_used_global);
                }
            }
        }

        return validity;
    }

    function sendAjax(ajaxData) {
        const request = new XMLHttpRequest();
        const url = window.ParamsDataPopin.wp_ajax_url;

        request.open('POST', url, true);
        request.send(ajaxData);

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }

            switch (response.status) {
                case 200:
                    if (response.action === 'register') {
                        switch (document.querySelector('.popin.signin').dataset.from) {
                            case 'saveSearchBtn':
                            case 'favBtnHome':
                            case 'favBtnSingleOffer':
                                window.location.reload();
                                break;
                            case 'singleOffer':
                                window.location.href = `/candidature/${document.querySelector('main').dataset.reference}/#compte-cree`;
                                break;
                            default:
                                window.location.href = response.url;
                                break;
                        }
                        break;
                    }
                    break;
                case 201:
                    if (response.action === 'register') {
                        formSigninRecruteurs.classList.remove('loading-please-wait');

                        Utils.closeDsfrModal('modal-signin-recruteurs');

                        Utils.banner(
                            'valid',
                            response.message.title,
                            response.message.subtitle,
                            '#modal-recruteurs-opener',
                        );

                    }
                    break;
                case 202:
                    break;
                case 203:
                    break;
                case 500:
                    if (response.action === 'register') {
                        formSigninRecruteurs.classList.remove('loading-please-wait');

                        Utils.closeDsfrModal('modal-signin-recruteurs');

                        Utils.banner(
                            'error',
                            response.message.title,
                            response.message.subtitle,
                            '#modal-recruteurs-opener',
                        );

                    }
                    break;
                default:
                    break;
            }
        };
    }

    function checkPassword() {
        // 14 characters at least
        // 1 numeric character at least
        // 1 lowercase character at least
        // 1 uppercase character at least
        // 1 special character at least

        password = false;

        const formats = {
            length: inputPassword.value.length >= lengthLimit,
            numeric: !!inputPassword.value.match(numericRegex),
            lowercase: !!inputPassword.value.match(lowercaseRegex),
            uppercase: !!inputPassword.value.match(uppercaseRegex),
            special: !!inputPassword.value.match(specialRegex),
        };

        inputPasswordFormat.forEach(format => {
            if (formats[format.dataset.check]) {
                format.classList.remove('icon-dot', 'fr-icon-error-line');
                format.classList.add('fr-icon-success-line');
                format.nextElementSibling.querySelector('.sr-only').textContent = 'Valide :';
            } else {
                format.classList.remove('icon-dot', 'fr-icon-success-line');
                format.classList.add('fr-icon-error-line');
                format.nextElementSibling.querySelector('.sr-only').textContent = 'Non valide :';
            }
        });

        if (formats.length == true && formats.numeric == true && formats.lowercase == true && formats.uppercase == true && formats.special == true) {
            password = true;
        }

        return password;
    }

    function checkForm() {
        init = false;

        if (!formFieldsValidate()) {
            formSigninRecruteurs.classList.remove('loading-please-wait');
            formSigninRecruteurs.querySelector('.fr-input-group.fr-input-group--error').scrollIntoView();
            document.querySelector('[aria-invalid="true').focus();
        } else {
            formSigninRecruteurs.classList.add('loading-please-wait');

            if (!checkPassword()) {
                addErrorMessage(inputPassword);
                inputPassword.closest('.fr-input-group').classList.add('error');
                inputPassword.setAttribute('aria-invalid', true);
                formSigninRecruteurs.classList.remove('loading-please-wait');
                formSigninRecruteurs.querySelector('.fr-input-group.fr-input-group--error').scrollIntoView();
                document.querySelector('[aria-invalid="true').focus();
            } else {
                const ajaxData = new FormData();

                ajaxData.append('action', dataAction);
                ajaxData.append('nonce', window.ParamsDataPopin.nonce);

                dataSigninFields.forEach(dataSigninField => {
                    const key = dataSigninField.dataset.signin;
                    let value = '';

                    if (dataSigninField.localName === 'ul' || key == "user_civility" || key == "user_versant") {
                        value = dataSigninField.querySelector(':checked').value;
                    } else {
                        value = dataSigninField.value;
                    }

                    if (value === 'Non renseigné') {
                        value = '';
                    }

                    if (key !== undefined) {
                        ajaxData.append(key, value);
                    }

                });

                inputPassword.closest('.fr-input-group').classList.remove('fr-input-group--error');
                inputPassword.setAttribute('aria-invalid', false);

                sendAjax(ajaxData);
            }
        }
    }

    inputPassword.addEventListener('input', checkPassword, false);

    inputSubmit.addEventListener('click', event => {
        event.preventDefault();
        checkForm();
    });
};
